import { API_URL } from 'app/constants/environments';

import {
  DashboardSummary,
  ItemsPickUpData,
  ParLevelData,
  PostedStockRunChartData,
  SessionChartData,
} from './types';
import axios, { AxiosResponse } from 'axios';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const DASHBOARD_SUMMARY_URL = `${API_URL}/api`;
const CHART_STOCK_RUN_URL = `${DASHBOARD_SUMMARY_URL}`;
const CHART_SESSIONS_URL = `${DASHBOARD_SUMMARY_URL}`;

export const DEFAULT_STOCK_CHART_DATA = {
  time: [],
  count: [],
};

export const getSummary = (query: string) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios.get(`${DASHBOARD_SUMMARY_URL}/orgs/${organizationId}/dashboard?${query}`).then(
    (
      res: AxiosResponse<{
        data: DashboardSummary;
      }>,
    ) => {
      return res.data.data;
    },
  );
};

export const getSessionChartData = (query: string) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(`${CHART_SESSIONS_URL}/orgs/${organizationId}/dashboard/chart-sessions?${query}`)
    .then(
      (
        res: AxiosResponse<{
          data: SessionChartData;
        }>,
      ) => {
        return res.data.data;
      },
    );
};
// .catch(() => {
//   return DEFAULT_STOCK_CHART_DATA;
// });

export const getPostedStockRunChartData = (orgId: number | undefined) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(`${CHART_STOCK_RUN_URL}/orgs/${organizationId}/dashboard/chart-stockrun?orgId=${orgId}`)
    .then(
      (
        res: AxiosResponse<{
          data: PostedStockRunChartData;
        }>,
      ) => {
        return res.data.data;
      },
    )
    .catch(() => {
      return DEFAULT_STOCK_CHART_DATA;
    });
};

export const getItemsPickUp = (fromDate: string, toDate: string, orgId: number | undefined) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(
      `${DASHBOARD_SUMMARY_URL}/orgs/${organizationId}/dashboard/chart-pickup?from=${fromDate}&to=${toDate}&orgId=${orgId}`,
    )
    .then(
      (
        res: AxiosResponse<{
          data: ItemsPickUpData;
        }>,
      ) => {
        return res.data.data;
      },
    );
};

export const getParLevelData = (fromDate: string, toDate: string, orgId: number | undefined) => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(
      `${DASHBOARD_SUMMARY_URL}/orgs/${organizationId}/dashboard/chart-performance?from=${fromDate}&to=${toDate}&orgId=${orgId}`,
    )
    .then(
      (
        res: AxiosResponse<{
          data: ParLevelData;
        }>,
      ) => {
        return res.data.data;
      },
    )
    .catch(() => {
      return {
        bottomParLevel: { items: [], values: [] },
        topParLevel: { items: [], values: [] },
      };
    });
};
